import { JsonApiDecorator } from '../json-api/JsonApiDecorator';
import { buildGenericProps } from './buildGenericProps';
import { connect } from 'react-redux';

export const connectGenericProps = config => {
  const mapGenericProps = (state, ownProps) => {
    if (typeof config === 'function') {
      config = config(ownProps);
    }
    const { entity, includes, selectMember, metaEntities = [] } = config;
    let pickedProps = {};
    let allIncludes;

    if (config?.pickContainerProps) {
      pickedProps = config?.pickContainerProps(ownProps);
    }

    if (state.api.currentEntityId && selectMember?.selectIncludes) {
      allIncludes = [...new Set(includes.concat(selectMember.selectIncludes))];
    }

    const genericProps = buildGenericProps(state, entity, allIncludes || includes, metaEntities);
    const apiStore = new JsonApiDecorator(state.api);
    const bundleStore = state[config.bundleReducer];
    const { route, params, router, location, routeParams, match } = ownProps;
    const props = {
      ...genericProps,
      ...pickedProps,
      config,
      apiStore,
      route,
      router,
      params,
      location,
      routeParams,
      match,
      ...bundleStore,
    };
    const stateProps = typeof config.mapStateToProps === 'function' ? config.mapStateToProps(state, props) : {};
    return {
      ...props,
      ...stateProps,
    };
  };

  return connect(mapGenericProps);
};
